/**
Project: Voice Panel (c)
Title: Alert Info Message
Description: Component for displaying the info message as alert
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { Text, Alert, InfoIcon, Button } from "@fluentui/react-northstar";

const AlertInfoMessage = ({ content, linkDetails, fitted = true }) => {
  return (
    <Alert
      fitted={fitted}
      icon={<InfoIcon className="page-alert-info-icon" />}
      className="page-alert-info"
      content={
        <>
          <Text className="page-alert-info-text">
            {content}
          </Text>
          <>
            {linkDetails && linkDetails.label && linkDetails.callback ? (
              <Button
                text
                primary
                inline="true"
                content={linkDetails.label}
                className="page-alert-link-details"
                onClick={linkDetails.callback}
                //aria-label="Hover or focus button"
              />
            ) : null}
          </>
        </>
      }
    ></Alert>
  );
};

export default AlertInfoMessage;
